var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.message)?_c('div',{staticClass:"validation-error"},[_c('p',{staticClass:"validation-error__message",attrs:{"data-test-id":"validation-error-message"}},[_vm._t("default",[_vm._v(_vm._s(_vm.message))])],2)]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }